import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import App from './App';

import './style.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <>
    <App />
    <ToastContainer 
      position="top-center"
      autoClose={4000000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      toastClassName="custom-error-toast"
      pauseOnHover
      theme="colored"
    />
  </>
);
